export default (value, options) =>
  value || (options.hash.replacement || '\u2014')
